import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "md:absolute md:xy-center md:w-full" }
const _hoisted_2 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-10"
}
const _hoisted_4 = { class: "md:w-1/2 flex flex-col" }
const _hoisted_5 = { class: "my-10 md:mt-0 md:flex" }
const _hoisted_6 = { class: "w-full relative" }
const _hoisted_7 = { class: "w-full relative mt-10 md:mt-0 md:ml-10" }

import { computed } from 'vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import CMSLinkHandler from '@/shared/content/blocks/helpers/CMSLinkHandler.vue';
import { CollageTileLayout } from '@/shared/content/blocks/collage-layouts/collage-layout.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileProductCategoryLayout',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: CollageTileLayout }



const blockList = computed(() => {
    return [
        {
            data: props.content.tiles[0].model,
            aspectRatio: {
                'max-xs': 2 / 3,
                'max-sm': 1 / 1,
                default: 500 / 650,
            },
        },
        {
            data: props.content.tiles[1].model,
            aspectRatio: {
                'max-md': 1 / 1,
                default: 158 / 200,
            },
        },
        {
            data: props.content.tiles[2].model,
            aspectRatio: {
                'max-md': 1 / 1,
                default: 158 / 200,
            },
        },
        {
            data: props.content.tiles[3].model,
            aspectRatio: {
                'max-md': 1 / 1,
                default: 304 / 300,
            },
        },
    ];
});

const flexOrderClass = computed(() => {
    return props.content.mirrorLayoutOnFirstSlide ? 'md:flex-row-reverse' : 'md:flex-row';
});

const flexOrderMarginBlockOne = computed(() => {
    return props.content.mirrorLayoutOnFirstSlide ? 'md:ml-10' : 'md:mr-10';
});

const flexOrderBlockFour = computed(() => {
    return props.content.mirrorLayoutOnFirstSlide ? 'md:ml-auto' : '';
});

const flexOrderLinkPosition = computed(() => {
    return props.content.mirrorLayoutOnFirstSlide ? 'absolute top-0 m-20 right-0' : 'absolute top-0 m-20 left-0';
});

const flexOrderBlockOneTextPosition = computed(() => {
    return props.content.mirrorLayoutOnFirstSlide ? 'text-right right-0' : 'left-0';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["o-tile-wrapper mx-20 flex flex-col md:mx-10", _unref(flexOrderClass)]),
    style: _normalizeStyle('color:' + __props.content.textColor)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["relative md:w-1/2 md:overflow-hidden", _unref(flexOrderMarginBlockOne)])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(MediaHandler, {
          "media-block": _unref(blockList)[0].data.media,
          "media-aspect-ratio": _unref(blockList)[0].aspectRatio,
          "video-disable-on-mobile": __props.content.disableVideoOnMobile
        }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"])
      ]),
      (_unref(blockList)[0].data.link)
        ? (_openBlock(), _createBlock(CMSLinkHandler, {
            key: 0,
            class: _normalizeClass(_unref(flexOrderLinkPosition)),
            "link-block": _unref(blockList)[0].data.link,
            "style-as-button": true
          }, null, 8, ["class", "link-block"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute bottom-0 m-20 sm:w-2/3 md:mb-50 lg:mb-90", _unref(flexOrderBlockOneTextPosition)])
      }, [
        (_unref(blockList)[0].data.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref(blockList)[0].data.title), 1))
          : _createCommentVNode("", true),
        (_unref(blockList)[0].data.text)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(blockList)[0].data.text), 1))
          : _createCommentVNode("", true),
        (_unref(blockList)[0].data.link)
          ? (_openBlock(), _createBlock(CMSLinkHandler, {
              key: 2,
              "link-block": _unref(blockList)[0].data.link,
              "show-arrow-icon": true,
              "underline-on-hover": true
            }, null, 8, ["link-block"]))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(MediaHandler, {
            "media-block": _unref(blockList)[1].data.media,
            "media-aspect-ratio": _unref(blockList)[1].aspectRatio,
            "video-disable-on-mobile": __props.content.disableVideoOnMobile
          }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"]),
          (_unref(blockList)[1].data.link)
            ? (_openBlock(), _createBlock(CMSLinkHandler, {
                key: 0,
                class: _normalizeClass(_unref(flexOrderLinkPosition)),
                "link-block": _unref(blockList)[1].data.link,
                "style-as-button": true
              }, null, 8, ["class", "link-block"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(MediaHandler, {
            "media-block": _unref(blockList)[2].data.media,
            "media-aspect-ratio": _unref(blockList)[2].aspectRatio,
            "video-disable-on-mobile": __props.content.disableVideoOnMobile
          }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"]),
          (_unref(blockList)[2].data.link)
            ? (_openBlock(), _createBlock(CMSLinkHandler, {
                key: 0,
                class: _normalizeClass(_unref(flexOrderLinkPosition)),
                "link-block": _unref(blockList)[2].data.link,
                "style-as-button": true
              }, null, 8, ["class", "link-block"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["relative md:w-2/3", _unref(flexOrderBlockFour)])
      }, [
        _createVNode(MediaHandler, {
          "media-block": _unref(blockList)[3].data.media,
          "media-aspect-ratio": _unref(blockList)[3].aspectRatio,
          "video-disable-on-mobile": __props.content.disableVideoOnMobile
        }, null, 8, ["media-block", "media-aspect-ratio", "video-disable-on-mobile"]),
        (_unref(blockList)[3].data.link)
          ? (_openBlock(), _createBlock(CMSLinkHandler, {
              key: 0,
              class: _normalizeClass(_unref(flexOrderLinkPosition)),
              "link-block": _unref(blockList)[3].data.link,
              "style-as-button": true
            }, null, 8, ["class", "link-block"]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 6))
}
}

})